"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorMessage = require("./ErrorMessage");
Object.keys(_ErrorMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorMessage[key];
    }
  });
});